import {
  useJournalSectionPersonnelPageConfig,
  type JournalSectionPersonnelPageNumber,
} from "../../model/use-journal-section-personnel-page-config";
import { JournalSectionPersonnel } from "../journal-section-personnel";

type JournalSectionPersonnelPageProps = {
  sectionNumber: JournalSectionPersonnelPageNumber;
};

export const JournalSectionPersonnelPage = ({
  sectionNumber,
}: JournalSectionPersonnelPageProps) => {
  const config = useJournalSectionPersonnelPageConfig(sectionNumber);

  return <JournalSectionPersonnel {...config} />;
};
